import type { TFunction } from 'i18next';

/**
 * The label keys the lead detail export names (SDD-020 §8.3, prompt 28 Decision 6). The
 * service publishes the same list in api/exports/; a unit test fails when they differ, and the
 * typed `t` fails the build when a key has no text.
 */
export const LEAD_EXPORT_LABEL_KEYS = [
  'column.field',
  'column.value',
  'column.versions.changeKind',
  'column.versions.reason',
  'column.versions.recordedAt',
  'column.versions.recordedBy',
  'column.versions.status',
  'field.code',
  'field.createdAt',
  'field.createdBy',
  'field.data',
  'field.effectiveFrom',
  'field.parentPolicyCode',
  'field.partners',
  'field.policyCode',
  'field.policyholder',
  'field.premiumMonthly',
  'field.status',
  'field.validUntil',
  'sheet.overview',
  'sheet.versions',
] as const;

export type LeadExportLabelKey = (typeof LEAD_EXPORT_LABEL_KEYS)[number];

/** The `labels` map of the detail export, in the reader's language. */
export function buildLeadExportLabels(t: TFunction<'insurance'>): Record<string, string> {
  return Object.fromEntries(
    LEAD_EXPORT_LABEL_KEYS.map((key) => [key, t(`exportLabels.lead.${key}`)]),
  );
}
